
import { useEffect, useState } from "react";
import rewardd from "../rewardd.jpg";
import cashback from "../rewardd.jpg";
import referearn from "../rewardd.jpg";
import ReferEarn from "./ReferEarn";
import festival from "../rewardd.jpg";
import "./Notifications.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import CouponsTable from "./CouponsTable";
import ReferandearnTable from "./ReferandearnTable";
import { useLocation } from "react-router-dom";

const Notifications = () => {
  const [activeTab, setActiveTab] = useState("coupons");
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [applyLoading, setApplyLoading] = useState(false);
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const location = useLocation();

  const cashbackData = [
    { image: cashback, amount: "₹10", message: "Cashback on first order" },
    { image: rewardd, amount: "₹25", message: "Cashback on second order" },
    { image: referearn, amount: "₹50", message: "Cashback on referral" },
    { image: festival, amount: "₹100", message: "Cashback on festive offer" },
  ];

  // Check for coupon from navigation state
  useEffect(() => {
    const couponFromState = location.state?.coupon;
    if (couponFromState) {
      console.log("Coupon from state:", couponFromState);
    }
  }, [location]);

  // Fetch coupons on component mount
  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!userId) {
          console.error("User ID not found in local storage.");
          alert("❌ User not logged in! Please login again.");
          return;
        }

        if (!token) {
          console.error("Auth token not found.");
          alert("❌ Session expired! Please login again.");
          return;
        }

        setLoading(true);
        const response = await axios.get(
          `https://backend.maamaas.com/food/api/coupon/user/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "*/*",
            },
          }
        );
        console.log("Coupon API Response:", response.data);

        if (Array.isArray(response.data)) {
          setCoupons(response.data);
        } else {
          console.error("Unexpected API response format:", response.data);
          setCoupons([]);
        }
      } catch (error) {
        console.error("❌ Error fetching coupons:", error);
        alert("Failed to fetch coupons. Please try again later.");
        setCoupons([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCoupons();
  }, []);

// Notifications.jsx - Updated handleApplyCoupon function
const handleApplyCoupon = async (couponId, couponCode) => {
  if (applyLoading) return;
  
  try {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");
    const cartId = localStorage.getItem("cartId");
    
    console.log("CartId from localStorage:", cartId);
    console.log("UserId:", userId);

    if (!userId) {
      alert("❌ User not logged in! Please login again.");
      return;
    }

    if (!token) {
      alert("❌ Session expired! Please login again.");
      return;
    }

    if (!cartId) {
      alert("❌ No cart found! Please add items to your cart first.");
      return;
    }

    setApplyLoading(true);
    
    // ✅ CORRECT REQUEST BODY FOR APPLYING COUPON
    const requestBody = {
      id: Number(couponId),  // ✅ Include coupon ID
      applyCoupon: "APPLIED"
    };

    console.log("Applying coupon with body:", requestBody);
    console.log("API URL:", `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`);

    // Apply coupon to cart
    const applyResponse = await axios.put(
      `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
      requestBody,  // ✅ Send correct body
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        },
      }
    );

    console.log("Coupon apply response:", applyResponse.data);

    if (applyResponse.status === 200 || applyResponse.status === 201) {
      // ✅ Store applied coupon info
      const couponData = {
        id: couponId,
        code: couponCode,
        appliedAt: new Date().toISOString()
      };
      
      localStorage.setItem('appliedCoupon', JSON.stringify(couponData));
      
      // ✅ Trigger storage event for real-time update
      window.dispatchEvent(new StorageEvent('storage', {
        key: 'couponApplied',
        newValue: JSON.stringify(couponData)
      }));
      
      alert(`✅ Coupon ${couponCode} applied successfully!`);
      
      // ✅ Navigate back to refresh cart page
      navigate(-1);
      
      // ✅ Optional: Force page reload to ensure fresh data
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } else {
      alert("⚠️ Coupon could not be applied.");
    }
  } catch (error) {
    console.error("❌ Error applying coupon:", error);
    
    if (error.response) {
      const errorMessage = error.response.data?.message || error.response.data;
      console.log("Error response data:", errorMessage);
      
      if (error.response.status === 400) {
        alert("⚠️ " + (errorMessage || "Coupon conditions not met"));
      } else if (error.response.status === 404) {
        alert("❌ Cart not found. Please add items to cart first.");
      } else if (error.response.status === 401) {
        alert("❌ Session expired. Please login again.");
        localStorage.removeItem("authToken");
        localStorage.removeItem("userId");
        navigate("/login");
      } else {
        alert(`❌ ${errorMessage || "Failed to apply coupon"}`);
      }
    } else {
      alert("❌ Network error. Please try again.");
    }
  } finally {
    setApplyLoading(false);
  }
};

  const tabStyle = {
    padding: "10px 20px",
    border: "none",
    background: "#ddd",
    cursor: "pointer",
    margin: "0 10px",
    borderRadius: "5px",
    fontSize: "24px"
  };

  const activeTabStyle = {
    ...tabStyle,
    background: "#ee6521",
    color: "white",
  };

  const cardStyle = {
    // height: "150px",
    background: "#fff",
    borderRadius: "12px",
    padding: "15px",
    color: "#333",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "center",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    position: "relative",
    border: "2px dashed #ee6521",
    overflow: "hidden"
  };

  const buttonStyle = {
    marginTop: "10px",
    background: "#ee6521",
    color: "#fff",
    width: "120px",
    border: "none",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "20px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 4px",
    opacity: applyLoading ? 0.6 : 1,
  };

  const rewardCardStyle = { width: "200px", height: "220px", background: "#ee6521", borderRadius: "20px" };
  const rewardImageStyle = { width: "200px", height: "120px", borderTopLeftRadius: "20px", borderTopRightRadius: "20px" };

  return (
    <div>
      <div style={{ marginTop: "90px" }}>
        <div style={{ scrollbarWidth: "none" }} className="notificationpage-scroll-data">
          {/* Tab Buttons */}
          <div
            className="tab-buttons-container"
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              marginBottom: "20px",
              gap: "10px",
            }}
          >
            {/* <button
              onClick={() => setActiveTab("coupons")}
              style={activeTab === "coupons" ? activeTabStyle : tabStyle}
            >
              Coupons
            </button> */}
            {/* <button
              onClick={() => setActiveTab("rewards")}
              style={activeTab === "rewards" ? activeTabStyle : tabStyle}
            >
              Rewards
            </button> */}
            {/* <button
              onClick={() => setActiveTab("refer")}
              style={activeTab === "refer" ? activeTabStyle : tabStyle}
            >
              Refer & Earn
            </button> */}
            {/* <button
              onClick={() => setActiveTab("cashback")}
              style={activeTab === "cashback" ? activeTabStyle : tabStyle}
            >
              Cashback
            </button> */}
          </div>

          {/* Coupons Section */}
          {activeTab === "coupons" && (
            <div>
              {loading ? (
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <p>Loading coupons...</p>
                </div>
              ) : coupons.length === 0 ? (
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <p>No coupons available at the moment.</p>
                </div>
              ) : (
                <div className="card-container" style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                  gap: "20px",
                  padding: "20px",
                }}>
                  {coupons.map((coupon) => (
                    <div key={coupon.id} style={cardStyle}>
                      <div>
                        <p style={{ fontSize: "20px", fontWeight: "bold" }}>
                          {coupon.discountType === "PERCENTAGE" 
                            ? `${coupon.discountPercentage}% OFF`
                            : coupon.discountAmount 
                              ? `₹${coupon.discountAmount} OFF`
                              : coupon.discountPercentage 
                                ? `${coupon.discountPercentage}% OFF`
                                : "Special Offer"}
                        </p>
                        <p style={{ margin: "5px 0", fontSize: "14px", color: "#666" }}>
                          Code: <span style={{ fontWeight: "bold", color: "#ee6521" }}>{coupon.code}</span>
                        </p>
                        {/* {coupon.minimumOrderValue && (
                          <p style={{ fontSize: "11px", color: "#999" }}>
                            Min order: ₹{coupon.minimumOrderValue}
                          </p>
                        )} */}
                        <p style={{ fontSize: "10px", color: "#999" }}>
                          Valid till: {new Date(coupon.endDate).toLocaleDateString()}
                        </p>
                      </div>
                      <button
                        style={buttonStyle}
                        onClick={() => handleApplyCoupon(coupon.id, coupon.code)}
                        disabled={applyLoading}
                      >
                        {applyLoading ? "Applying..." : "Apply"}
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Rewards Section */}
          {activeTab === "rewards" && (
            <div style={{ padding: "0 15px", maxWidth: "100%", overflowX: "hidden" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <div style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                  gap: "16px",
                  width: "100%",
                }}>
                  {[0, 1, 2, 3].map((_, index) => (
                    <div key={index} style={{ minWidth: "0", overflow: "hidden" }}>
                      <div style={{
                        background: "#ffffff",
                        borderRadius: "12px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      }}>
                        <img
                          src={rewardd}
                          alt="reward"
                          style={{
                            width: "100%",
                            height: "120px",
                            objectFit: "cover",
                          }}
                        />
                        <div style={{
                          padding: "12px",
                          background: "linear-gradient(135deg, #6e8efb, #a777e3)",
                          color: "white",
                          flexGrow: "1",
                        }}>
                          <h4 style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "4px" }}>
                            ₹10 - ₹100
                          </h4>
                          <p style={{ fontSize: "14px", marginBottom: "0" }}>
                            Cashback on next delivery
                          </p>
                        </div>
                        <div style={{ padding: "12px", background: "white" }}>
                          <button style={{
                            width: "100%",
                            background: "white",
                            color: "#333",
                            border: "1px solid #ddd",
                            fontWeight: "500",
                            padding: "8px",
                            borderRadius: "4px",
                          }}>Apply</button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Refer & Earn Section */}
          {activeTab === "refer" && (
            <div style={{ maxHeight: "800px", overflowY: "auto", scrollbarWidth: "none" }}>
              <ReferEarn />
            </div>
          )}

          {/* Cashback Section */}
          {activeTab === "cashback" && (
            <div>
              <div className="reward-data">
                <div className="row g-4">
                  {cashbackData.map((item, index) => (
                    <div key={index} className="col-lg-3 col-md-6 col-sm-12">
                      <div style={rewardCardStyle}>
                        <img style={rewardImageStyle} src={item.image} alt="reward" />
                        <div className="cashback">
                          <h4 className="rupee">{item.amount}</h4>
                          <p style={{ color: "#fff", fontSize: "14px" }}>{item.message}</p>
                        </div>
                        <div className="d-flex justify-content-center">
                          <Button className="mt-1" style={{ backgroundColor: "white", color: "black" }}>
                            Apply
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <CouponsTable />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Notifications;